import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

// Register locale data BEFORE bootstrapping the application
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeFr, 'fr-FR');

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
